import {createSelector} from '@reduxjs/toolkit'

const confirmApplicationSubmissionSelector = createSelector(
    [state => state.components],
    ({confirmApplicationSubmission}) => {
        return confirmApplicationSubmission
    }
)

export const confirmApplicationSubmissionSelect = (state) => ({
    confirmApplicationSubmission : confirmApplicationSubmissionSelector(state)
})
